
import React from "react";
import {
  Box,
  Card,
  CardActionArea,
  CardContent,
  Typography,
  Stack,
  Avatar,
} from "@mui/material";

import {
  PhoneOutlined,
  SupportAgentOutlined,
  AccessTimeOutlined,
} from "@mui/icons-material";

const phones = [
  {
    title: "Абонентный отдел",
    number: "8 (02133) 6-83-88",
    href: "tel:+375213368388",
    schedule: "ПН–ПТ, с 8:00 до 17:00",
    extra: "Обед с 13:00 до 14:00",
    Icon: PhoneOutlined,
  },
  {
    title: "Дежурный диспетчер",
    number: "+375 (29) 595-78-85",
    href: "tel:+375295957885",
    schedule: "Ежедневно, с 9:00 до 21:00",
    extra: "МТС",
    Icon: SupportAgentOutlined,
  },
];

export default function ContactPhones() {
  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: {
          xs: "1fr",
          sm: "repeat(2, minmax(0, 1fr))",
        },
        gap: 2,
        width: "100%",
      }}
    >
      {phones.map((phone) => (
        <Card
          key={phone.href}
          variant="outlined"
          sx={{
            borderRadius: 2,
            height: "100%",
            transition: "0.2s",
            "&:hover": {
              borderColor: "primary.main",
              boxShadow: 3,
              transform: "translateY(-2px)",
            },
          }}
        >
          <CardActionArea
            component="a"
            href={phone.href}
            aria-label={`Позвонить: ${phone.title}, ${phone.number}`}
            sx={{ height: "100%" }}
          >
            <CardContent sx={{ p: 3 }}>
              <Stack direction="row" spacing={2} alignItems="center">
                <Avatar
                  sx={{
                    bgcolor: "primary.light",
                    color: "primary.contrastText",
                  }}
                >
                  <phone.Icon />
                </Avatar>

                <Box sx={{ minWidth: 0 }}>
                  <Typography
                    variant="subtitle1"
                    fontWeight={600}
                  >
                    {phone.title}
                  </Typography>

                  <Typography
                    variant="h6"
                    color="primary.main"
                    fontWeight={700}
                    sx={{ mt: 0.5 }}
                  >
                    {phone.number}
                  </Typography>
                </Box>
              </Stack>

              <Stack spacing={0.7} sx={{ mt: 2 }}>
                <Stack direction="row" spacing={1} alignItems="center">
                  <AccessTimeOutlined
                    sx={{ fontSize: 18, color: "text.secondary" }}
                  />
                  <Typography variant="body2">
                    {phone.schedule}
                  </Typography>
                </Stack>

                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{ pl: 3.3 }}
                >
                  {phone.extra}
                </Typography>
              </Stack>
            </CardContent>
          </CardActionArea>
        </Card>
      ))}
    </Box>
  );
}
